<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <router-link class="my-3 d-inline-block" :to="{ name: 'event', params: { id: event.id }}">
                        Back to All Invites
                    </router-link>

                    <h2 class="mb-5">
                        The invitation for {{ invite.first_name }} {{ invite.last_name }} to {{ event.name }}
                    </h2>

                    <p>UUID: {{ invite.uuid }}</p>

                    <div class="info-table">
                        <div class="info-table__row info-table__row--head">
                            <div class="info-table__item info-table__item--bold">
                                Status
                            </div>

                            <div class="info-table__item info-table__item--bold">
                                First Name
                            </div>

                            <div class="info-table__item info-table__item--bold">
                                Last Name
                            </div>

                            <div class="info-table__item info-table__item--bold">
                                Phone
                            </div>

                            <div class="info-table__item info-table__item--bold">
                                Email
                            </div>
                        </div>

                        <div class="info-table__row">
                            <div class="info-table__item">
                                {{ invite.status }}
                            </div>

                            <div class="info-table__item">
                                {{ invite.first_name }}
                            </div>

                            <div class="info-table__item">
                                {{ invite.last_name }}
                            </div>

                            <div class="info-table__item">
                                {{ invite.phone }}
                            </div>

                            <div class="info-table__item">
                                {{ invite.email }}
                            </div>
                        </div>
                    </div>

                    <div class="mt-4 mb-3">
                        <div class="sms-label mb-3" id="sms">
                            Should this invitee receive SMS communications from Clubs Away?
                        </div>

                        <checkbox
                            :initialvalue="invite.is_sms_opt_in"
                            @box-checked="toggleSmsOptIn">
                        </checkbox>
                    </div>

                    <div v-if="question_answer_pairs.length" class="mt-5">
                        <h3 class="mb-3">
                            Questions
                        </h3>

                        <div class="info-table">
                            <div class="info-table__row info-table__row--head">
                                <div class="info-table__item info-table__item--bold">
                                    Question
                                </div>

                                <div class="info-table__item info-table__item--bold">
                                    Answer
                                </div>
                            </div>

                            <div class="info-table__row" v-for="qa in question_answer_pairs">
                                <div class="info-table__item">
                                    {{ qa.question }}
                                </div>

                                <div class="info-table__item">
                                    {{ qa.answer }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5" v-if="invite.payments.length">
                        <h3 class="mb-3">
                            Payments
                        </h3>

                        <div v-if="invite.payments">
                            <div class="info-table">
                                <div class="info-table__row info-table__row--head">
                                    <div class="info-table__item info-table__item--bold">
                                        Date
                                    </div>

                                    <div class="info-table__item info-table__item--bold">
                                        Status
                                    </div>

                                    <div class="info-table__item info-table__item--bold">
                                        Receipt
                                    </div>

                                    <div class="info-table__item info-table__item--bold">
                                        Message
                                    </div>
                                </div>

                                <div class="info-table__row" v-for="payment in invite.payments">
                                    <div class="info-table__item">
                                        {{ payment.created_at }}
                                    </div>

                                    <div class="info-table__item">
                                        {{ translatePaymentStatus(payment.status) }}
                                    </div>

                                    <div class="info-table__item">
                                        <a v-if="payment.receipt_url" v-bind:href="payment.receipt_url" target="_blank">View receipt</a>
                                    </div>

                                    <div class="info-table__item">
                                        <span v-if="payment.error">{{ payment.error }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="messages mt-5" v-if="invite.messages.length">
                        <h3 class="">
                            Messages
                        </h3>

                        <div v-if="!invite.is_sms_opt_in" class="">
                            This invitee has opted out of SMS communication
                        </div>

                        <div v-else-if="!invite.phone">
                            This invitee has no phone number
                        </div>

                        <div v-else>
                            This invitee can receive SMS communication
                        </div>

                        <div class="mt-3">
                            <div class="info-table">
                                <div class="info-table__row info-table__row--head">
                                    <div class="info-table__item info-table__item--bold">
                                        Date
                                    </div>

                                    <div class="info-table__item info-table__item--bold">
                                        Status
                                    </div>

                                    <div class="info-table__item info-table__item--bold">
                                        Body
                                    </div>

                                    <div class="info-table__item info-table__item--bold">
                                        Error
                                    </div>

                                </div>

                                <div class="info-table__row" v-for="message in invite.messages">
                                    <div class="info-table__item">
                                        {{ message.created_at }}
                                    </div>

                                    <div class="info-table__item">
                                        {{ message.delivery_status }}
                                    </div>

                                    <div class="info-table__item">
                                        {{ message.message }}
                                    </div>

                                    <div class="info-table__item">
                                        {{ message.error }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
import inviteRepository from "@/repository/invites";
import Checkbox from "@/components/Checkbox";

export default {
    components: {
        Checkbox
    },
    props: ['id', 'invite_id'],

    data() {
        return {
            event: null,
            invite: null,
            status_options: [
                {
                    'value': 'UNSENT',
                    'text': 'Unsent'
                },
                {
                    'value': 'SENT',
                    'text': 'Sent'
                },
                {
                    'value': 'VIEWED',
                    'text': 'Viewed'
                },
                {
                    'value': 'ACCEPTED',
                    'text': 'Accepted'
                },
                {
                    'value': 'REJECTED',
                    'text': 'Rejected'
                },
            ],
            form:{},
            custom_field_labels:{},
            loaded: false,
            errors: {},
            payment_status_map: {
                'PAYMENT_INTENT_CREATED': "Payment form accessed",
                'FAILED': "Payment failed",
                'PAID': "Paid",
                'CANCELED': "Payment canceled"
            },
            question_answer_pairs: []
        }
    },

    mounted() {
        inviteRepository.getById(this.invite_id,
            {
                include: ['event', 'event.client', 'event.questions', 'answers', 'payments', 'messages']
            })
            .then(response => {
                this.invite = response.data;
                this.event = response.data.event;
                this.loaded = true;

                this.event.questions.forEach(question => {
                   var question_answer = this.invite.answers.find(answer => answer.question_id == question.id);

                   this.question_answer_pairs.push({
                       question: question.text,
                       answer: question_answer.text
                   });
                });

            });
    },

    computed: {
    },

    methods: {
        toTitleCase(str){
            return str.replace(/_/,' ').replace(/\b\S/g, t => t.toUpperCase());
        },

        translatePaymentStatus(status) {
            return this.payment_status_map[status];
        },

        toggleSmsOptIn(opted_in) {
            if (opted_in) {
                inviteRepository.smsOptIn(this.invite.uuid)
                    .then(response => {
                        this.invite.is_sms_opt_in = true;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Error',
                            text: 'Unable to change your SMS preferences',
                            duration: 10000
                        });
                    })
            } else {
                inviteRepository.smsOptOut(this.invite.uuid)
                    .then(response => {
                        this.invite.is_sms_opt_in = false;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Error',
                            text: 'Unable to change your SMS preferences',
                            duration: 10000
                        });
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
input, select {
    margin-bottom: 20px!important;
}

select {
    margin-bottom: 10px;
}

.view-invite {
    color: $color-gold!important;
    font-size: 20px;
}

@include media-breakpoint-up(md) {
    .info-table {
        display: flex;
        flex-direction: column;

        &__row {
            width: 100%;
            display: flex;
            //margin: 0 -10px;
            border-bottom: 1px solid $color-white;
            gap: 15px;
        }

        &__item {
            width: 25%;
            padding: 5px 0;
            flex-grow: 1;

            &--bold {
                font-weight: bold;
            }
        }
    }

    .info-table .info-table__row:last-child {
        border-bottom: none;
    }
}

@include media-breakpoint-down(md) {
    .info-table {

        &__row {
            padding-bottom: 10px;
            margin-bottom: 10px;
            border-bottom: 1px solid $color-white;
        }

        &__row--head {
            display: none;
        }

        &__row {

        }
    }
}


//table {
//    width: 100%;
//
//    thead th {
//        padding-bottom: 8px;
//    }
//
//    tr {
//        border-bottom: 1px solid $color-white;
//    }
//
//    td {
//        font-weight: 200;
//        width: 25%;
//        padding: 8px 10px;
//    }
//}

.qa,
.qa-head {
    display: flex;
    flex-flow: row;

    div {
        width: 50%;
    }
}

.qa-head {
    font-weight: bold;
    margin-bottom: 10px;
}
</style>